<template>
  <div class="sidebar bg-white p-20 p-relative">
    <div class="logo-container">
      <img class="logo" src="@/assets/img/logo/logo.jpeg" alt="Logo" />
    </div>
    <div v-if="loading" class="page-loading">
      <Loading />
    </div>
    <ul>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'Dashboard' }"
          :to="{ name: 'Dashboard' }"
        >
          <span class="material-icons-outlined">dashboard</span>
          <span>{{ $t("Menu.dashboard") }}</span>
        </router-link>
      </li>
      <!-- 
        <li>
            <router-link class="d-flex align-center fs-14 c-black rad-0-6 p-12"                     
            :class="{ active: $route.name === 'Lists' }"
            :to="{ name: 'Lists' }">
                <span class="material-icons-outlined">
                    speaker_notes
                    </span>
                <span>{{ $t("List.s') }}</span>
            </router-link>
        </li>
        -->
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'Apps' }"
          :to="{ name: 'Apps' }"
        >
          <span class="material-icons-outlined"> bookmarks </span>
          <span>{{ $t("Menu.apps") }}</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'AppLists' }"
          :to="{ name: 'AppLists' }"
        >
          <span class="material-icons-outlined"> book </span>
          <span>{{ $t("Menu.appLists") }}</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'Developers' }"
          :to="{ name: 'Developers' }"
        >
          <span class="material-icons-outlined"> code </span>
          <span>{{ $t("Menu.developers") }}</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'DeveloperLists' }"
          :to="{ name: 'DeveloperLists' }"
        >
          <span class="material-icons-outlined"> book </span>
          <span>{{ $t("Menu.developerLists") }}</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :class="{ active: $route.name === 'Packages' }"
          :to="{ name: 'Packages' }"
        >
          <span class="material-icons-outlined"> inventory_2 </span>
          <span>{{ $t("Menu.packages") }}</span>
        </router-link>
      </li>
      <li>
        <router-link
          class="d-flex align-center fs-14 c-black rad-0-6 p-12"
          :to="{ name: 'Logout' }"
        >
          <span class="material-icons-outlined"> logout </span>
          <span>{{ $t("Menu.logout") }}</span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import Loading from "@/components/user/layout/LoadingComponent.vue";
import { mapActions } from "vuex";

export default {
  name: "MenuComponent",
  components: {
    Loading,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions("pageTitle", ["updatePageTitle"]),
    ...mapActions({
      logout: "auth/logout",
    }),

    updateTitle(title) {
      this.updatePageTitle(title);
    },
    async logoutUser() {
      this.loading = true;
      await this.logout();
      this.$store.commit("CLEAR_USER_DATA");
      window.location = "/login";
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.logo-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 32px;
  width: 100%;
}

.logo {
  width: 28%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border-radius: 30%;
  padding: 2px;
  margin: 8px;
}

@media (max-width: 767px) {
  .logo-container .logo {
    width: 100%;
  }
}
</style>
